import { INITIALIZE_FORM } from '../actionTypes';
import { installerProfileActions } from '../reducer';

export default (values) => installerProfileActions[INITIALIZE_FORM](values);
